export const URL = process.env.LIRASYS_URL || 'https://app.angellira.com.br/';
